<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <v-card
    v-else
    class="EK-card mt-8 rounded-xl border-top border-right rounded-tr-0 EK-shadow IMTOrange"
  >
    <v-data-table
      dense
      :headers="headers"
      :items="schedules"
      :search="searchText"
      :items-per-page="10"
      :page.sync="page"
      @page-count="pageCount = $event"
      hide-default-footer
    >
      <template
        v-slot:header="{ number, day, times, exeptionDay, exeptionTimes, deleteItem }"
      >
        <tr class="header-tr">
          <th>{{ number }}</th>
          <th>
            <tr>
              <th>{{ day }}</th>
            </tr>
            <div class="d-flex justify-space-around">
              <span class="py-2">من</span>
              <span class="py-2">|</span>
              <span class="py-2">إلى</span>
            </div>
          </th>

          <th>
            <tr>
              <th>{{ times }}</th>
            </tr>
            <div class="d-flex justify-space-around">
              <span class="py-2">من</span>
              <span class="py-2">|</span>
              <span class="py-2">إلى</span>
            </div>
          </th>

          <th>{{ exeptionDay }}</th>
          <th>
            <tr>
              <th>{{ exeptionTimes }}</th>
            </tr>
            <div class="d-flex justify-space-around">
              <span class="py-2">من</span>
              <span class="py-2">|</span>
              <span class="py-2">إلى</span>
            </div>
          </th>

          <th>{{ deleteItem }}</th>
        </tr>
      </template>
      <template v-slot:item="{ item, index }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <tr v-on="on" v-bind="attrs" @click="goToDetails((page-1)*10+index)" :class="{ active: id == (page-1)*10+index }">
              <td>{{ (page-1)*10+index + 1 }}</td>
              <td>
                <div class="d-flex justify-space-around">
                  <span class="py-2">{{ getDay(item.fromDay) }}</span>
                  <span class="py-2">|</span>
                  <span class="py-2">{{ getDay(item.toDay) }}</span>
                </div>
              </td>
              <td>
                <div class="d-flex justify-space-around">
                  <span class="py-2">{{ item.open }}</span>
                  <span class="py-2">|</span>
                  <span class="py-2">{{ item.close }}</span>
                </div>
              </td>
              <td>
                {{ item.exeptionDay == null ? "لا يوجد" : getDay(item.exeptionDay) }}
              </td>
              <td>
                <div class="d-flex justify-space-around">
                  <span class="py-2">{{
                        !item.exeptionOpen
                        ? "0:0" 
                        : item.exeptionOpen
                    }}</span>
                    <span class="py-2">|</span>
                    <span class="py-2">{{
                        !item.exeptionClose
                        ? "0:0"
                        : item.exeptionClose
                    }}</span>
                </div>
              </td>
              <td>
                <v-btn @click="submitRemoveSchedule(item)" text>
                  <img src="/media/svg/table/delete.svg" alt="delete" />
                </v-btn>
              </td>
            </tr>
          </template>
          <span>انقر لعرض التفاصيل</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <div class="w-100 pb-10 mt-10">
    <a-pagination 
        
       
    :showTotal="(total) => `من أصل ${total} عنصر`"
    pageSize="10"

    v-model="page"
   
    :total="schedules.length"
   
    
    size="large" show-size-changer show-quick-jumper />
  </div>
  </v-card>
</template>
<style lang="scss" scoped>
.active {
  background: rgba(246, 156, 60, 0.5) !important;
}
</style>
<style lang="scss">
.v-application .text-start {
  text-align: center !important;
  border: thin solid rgba(246, 156, 60, 0.13);
}
.card-schedule {
  .header-tr th {
    text-align: center;
    font-size: 0.75rem;
    color: rgba(0, 0, 0, 0.6);
  }
  .header-tr > th {
    border: thin solid rgba(246, 156, 60, 0.13) !important;
  }
  table > thead > tr:last-child > th {
    border: thin solid rgba(246, 156, 60, 0.13) !important;
  }
}

td {
  user-select: none;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import loading from "@/components/loading";
import Swal from "sweetalert2";
import aPagination from  'ant-design-vue/lib/pagination'
export default {
  props: {
    id: String,
  },
  components: {
    loading,
    aPagination,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    searchText: "",
    headers: [
      {
        text: "رقم التسلسل",
        value: "number",
        sortable: false,
      },
      {
        text: "الأيام",
        value: "day",
        sortable: false,
      },
      {
        text: "الأوقات",
        value: "times",
        sortable: false,
      },
      {
        text: "اليوم المستثنى",
        value: "exeptionDay",
        sortable: false,
      },
      {
        text: "أوقات اليوم المستثنى",
        value: "exeptionTimes",
        sortable: false,
      },
      {
        text: "حذف",
        value: "deleteItem",
        sortable: false,
      },
    ],
    days: [
      { id: 1, name: "السبت" },
      { id: 2, name: "الأحد" },
      { id: 3, name: "الاثنين" },
      { id: 4, name: "الثلاثاء" },
      { id: 5, name: "الأربعاء" },
      { id: 6, name: "الخميس" },
      { id: 7, name: "الجمعة" },
    ],
  }),
  created() {
    this.fetchSchedules();
  },
  computed: {
    ...mapGetters(["schedules", "isLoading"]),
  },
  methods: {
    ...mapActions(["fetchSchedules", "removeSchedule"]),
    getDay(id) {
      return this.days.find((item) => item.id == id).name;
    },
    goToDetails(index) {
      if (index != this.id) {
        this.$router.push(`${index}`);
      }
    },
    submitRemoveSchedule(item) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: "هل أنت متأكد؟",
          text: "هل فعلاً تريد حذف الموعد ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "نعم!",
          cancelButtonText: "إلغاء",
          reverseButtons: false,
        })
        .then((result) => {
          if (result.value) {
            this.removeSchedule(item);
            if (this.id != -1) {
              this.$router.push("./-1");
            }
          }
        });
    },
  },
};
</script>
